export enum PetsFilterParam {
  Search = 'q',
  IncludeUnapproved = 'include_unapproved',
}
